module.exports = __webpack_public_path__ + "img/Slice9-min.ea3d0c86.png";